import React from "react";
import AllFolder from '../../../assets/images/Ic_folder.png';

const FolderGrid = ({
    folders,
    selectedFolder,
    onFolderClick,
    showMenu,
    activeFolderMenu,
    openFolderMenu,
    openRenamePopup,
    openDeleteConfirm
}) => {
    return (
        <div className="folder-grid">
            {folders.map(folder => (
                <div
                    key={folder.folderId}
                    className={`folder-card ${selectedFolder?.folderId === folder.folderId ? "active" : ""
                        }`}
                    onClick={() => onFolderClick(folder)}
                    style={{ position: 'relative' }}
                >
                    <div className="folder-content">
                        <img src={AllFolder} alt="Folder" className="folder-icon" />
                        <p className="folder-outer-icon" title={folder.folderName}> {folder.folderName}</p>
                    </div>

                    {showMenu && (
                        <>
                            <button
                                type="button"
                                className="folder-actions-trigger"
                                onClick={(e) => {
                                    e.stopPropagation();   
                                    openFolderMenu(e, folder);
                                }}
                            >
                                ⋮
                            </button>

                            {activeFolderMenu === folder.folderId && (
                                <div
                                    className="folder-actions-dropdown"
                                    onClick={(e) => e.stopPropagation()} 
                                >
                                    <div
                                        onClick={(e) => {
                                            e.stopPropagation(); 
                                            openRenamePopup(folder);
                                        }}
                                    >
                                        Rename
                                    </div>

                                    <div
                                        style={{ color: 'red' }}
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            openDeleteConfirm(folder);
                                        }}
                                    >
                                        Delete
                                    </div>
                                </div>
                            )}
                        </>
                    )}
                </div>
            ))}
        </div>
    );
};

export default FolderGrid;